import styled from "styled-components"
import { Container as BaseContainer } from "../../../elements/Layout/styled"

export const Container = styled(BaseContainer)``
